import $ from 'jquery'

export default {
  // params: ['show'],
  inserted(el, binding) {
    const $el = $(el)
    const $c = $el.find($el.data('content-selector') || '[data-role=popover-content]')

    const config = binding.expression || {}

    $el.popover(
      $.extend(
        {
          placement: 'bottom'
        },
        config,
        {
          html: true,
          content: $c /* function(){
                let $cnt = $(this).find($el.data('content-selector') || '[data-role=popover-content]');
                $cnt.show();
                return $cnt;
            } */
        }
      )
    )

    const po = $el.data('bs.popover')
    const $pc = po.tip()

    $el.on('show.bs.popover', function() {
      $c.show()
      // self.params.show = true;
    })

    $el.on('hidden.bs.popover', function() {
      // self.params.show = false;
    })

    $(document).on('click', function(e) {
      var isOut = true

      $(e.target).parents().addBack().each(function() {
        if (this === $el[0] || this === $pc[0]) {
          isOut = false
        }
      })

      if (isOut) {
        $el.popover('hide')
        po.inState.click = false
      }
    })

    $pc.on('click', '[data-role=close-popover]', function() {
      $el.popover('hide')
      po.inState.click = false
    })
  }
}
